import { Component, computed, HostListener, OnDestroy, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ValidationConstants } from '../../constants/validation.constants';
import { AuthService } from '../../core/services/Auth/auth-service';
import { Quotes } from '@app/constants/quotes';
import { ThemeService } from '@app/core/services/theme/theme.service';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router'; // for meta 
import { Title, Meta } from '@angular/platform-browser';// for meta 
import { PreventLeadingSpaceDirective } from '@app/shared/components/utils/prevent-leading-space.directive';
import { Spinner } from '@app/shared/components/spinner/spinner';



interface LoginResponse {
  message?: string;
  multipleAgency?: boolean;
  data?: {
    agencies?: Array<{
      _id: string;
      name: string;
    }>;
    userID?: string;
    userName?: string;
    userData?: {
      _id: string;
      name: string;
      //## need login response used theme
      theme?: string;
      mode?: string;
      redirectTo?: string;
    };
    agencyData?: {
      _id: string;
      name: string;
      status: string;
    };
  };
  userData?: {
    _id: string;
    name: string;
    theme?: string;
    mode?: string;
    redirectTo?: string;
    [key: string]: any;
  };
  agencyData?: {
    _id: string;
    name: string;
    status: string;
    [key: string]: any;
  };
}
@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule, CommonModule, PreventLeadingSpaceDirective, Spinner],
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login implements OnInit, OnDestroy {
  loginForm: FormGroup;
  agencyForm: FormGroup;
  showPassword = false;
  entryPoint = 'left';
  isLoading = false;
  errorMessage = '';
  validationMessages = ValidationConstants.VALIDATION_MSG;
  allQuotes = Quotes.allQuotes;
  currentQuote = '';
  currentYear = new Date().getFullYear();
  agencies = signal<Array<{_id: string; name: string; status: string}>>([]);
  userID = signal('');
  userName = signal('');
  showAgencySelection = false;
  isUserTyping = false; // Track if user is actively typing
  isEmailTyping = false; // Track if user is typing in email field
  isPasswordTyping = false; // Track if user is typing in password field

    visibleAgencies = computed(() => {
   return this.agencies().slice(this.currentIndex(), this.currentIndex() + 2);
  });

  // agencies = [
  //   { id: 1, name: 'https://static3.toyotabharat.com/images/toyota-logo-main-136x24.svg' },
  //   { id: 2, name: 'https://mgmotor.scene7.com/is/image/mgmotor/mg-icon-004?fmt=png-alpha' },
  //   { id: 3, name: 'https://www.royalenfield.com/content/dam/royal-enfield/india/logos/logo.svg' },
  //   { id: 4, name: 'https://cdn.suzukimotorcycle.co.in/public-live/images/website/logo.jpg' }
  // ];

   currentIndex = signal(0);
  private subscription: Subscription | null = null;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private themeService: ThemeService,
    private route: ActivatedRoute, // for meta 
    private titleService: Title, // for meta 
    private metaService: Meta // for meta 
  ) {
    this.loginForm = this.fb.group({
      email: ['', [
        Validators.required,
        ValidationConstants.emailOrPhoneValidator()
      ]],
      passcode: ['', [
        Validators.required,
      ]]
    });

    this.agencyForm = this.fb.group({
      agency: ['', Validators.required]
    });

    // Add debounce to email field to prevent excessive validation calls
    const emailControl = this.loginForm.get('email');
    if (emailControl) {
      this.subscription = emailControl.valueChanges
        .pipe(
          debounceTime(300), // Wait 300ms after user stops typing
          distinctUntilChanged() // Only trigger if value actually changed
        )
        .subscribe(() => {
          // Trigger validation after debounce
          emailControl.updateValueAndValidity();
        });
    }
  }
  

  ngOnInit(): void {
    console.log('agencyyy',this.showAgencySelection)
    // Get or initialize load count
    const loadCount = parseInt(sessionStorage.getItem('loginLoadCount') || '0');
    sessionStorage.setItem('loginLoadCount', (loadCount + 1).toString());

    // Set random angle between -30 and 30 degrees
    const randomAngle = Math.floor(Math.random() * 61) - 30;
    document.documentElement.style.setProperty('--bike-angle', `${randomAngle}deg`);

    // Set random entry point
    const entryPoints = ['left', 'right', 'top', 'bottom'];
    this.entryPoint = entryPoints[Math.floor(Math.random() * entryPoints.length)];

    // If user is already logged in, redirect to dashboard silently
    // Use replaceUrl to avoid adding to browser history
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/dashboard'], { replaceUrl: true });
    }

    // Get a new random quote based on user fingerprint and timestamp
    this.initializeQuote();
      // For meta title and description //
    this.route.data.subscribe((data: { [key: string]: any }) => {
      if (data['title']) {
        this.titleService.setTitle(data['title']);
      }

      if (data['description']) {
        this.metaService.updateTag({
          name: 'description',
          content: data['description']
        });
      }
    });
    // For meta title and description //
  }

  private getUserFingerprint(): number {
    // Create a simple fingerprint based on browser info
    const userAgent = navigator.userAgent;
    const screenResolution = `${window.screen.width}x${window.screen.height}`;
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const language = navigator.language;

    // Create a string combining user-specific information
    const fingerprintString = `${userAgent}${screenResolution}${timeZone}${language}`;

    // Convert string to a number using a simple hash function
    let hash = 0;
    for (let i = 0; i < fingerprintString.length; i++) {
      const char = fingerprintString.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32-bit integer
    }
    return Math.abs(hash);
  }

  private initializeQuote() {
    // Get user fingerprint
    const fingerprint = this.getUserFingerprint();

    // Use current timestamp to ensure quote changes on refresh
    const timestamp = Date.now();

    // Combine fingerprint and timestamp to create a unique seed
    const combinedSeed = fingerprint + timestamp;

    // Use the combined seed to get a random index
    // We use modulo to ensure it's within the array bounds
    const randomIndex = Math.abs(combinedSeed % this.allQuotes.length);

    // Get quote at the calculated index
    this.currentQuote = this.allQuotes[randomIndex];

    // Ensure the quote is different from the last one if possible
    if (this.currentQuote === sessionStorage.getItem('lastQuote') && this.allQuotes.length > 1) {
      // If we got the same quote, use the next one in the array
      const nextIndex = (randomIndex + 1) % this.allQuotes.length;
      this.currentQuote = this.allQuotes[nextIndex];
    }

    // Save this quote as the last shown quote
    sessionStorage.setItem('lastQuote', this.currentQuote);
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      this.isUserTyping = false; // Reset typing state
      this.isEmailTyping = false; // Reset email typing state
      this.isPasswordTyping = false; // Reset password typing state

      const { email, passcode } = this.loginForm.value;

      this.authService.login(email, passcode).subscribe({
        next: (response:LoginResponse) => {
          // Handle response with agencies array (first response format)
          if (response.data?.agencies && response.data.agencies.length > 0) {
            this.isLoading = false;
            this.showAgencySelection = true;
            const userID = response.data.userID || '';
            const userName = response.data.userName || '';
            this.userID.set(userID);
            this.userName.set(userName);
            // Save userID and userName to localStorage for header component
            if (userID) {
              localStorage.setItem('userID', userID);
            }
            if (userName) {
              localStorage.setItem('userName', userName);
            }
            // Map agencies to include status field for consistency
            this.agencies.set(response.data.agencies.map(agency => ({
              _id: agency._id,
              name: agency.name,
              status: 'active' // Default status if not provided
            })));
             this.currentIndex.set(0);
            console.log('agendcyy submii',this.showAgencySelection);
            return;
          }

          // Handle response with userData and agencyData at root (second response format)
          if (response.userData && response.agencyData) {
            // Apply user's saved theme and mode
            this.applyUserTheme(response.userData);
            
            // Clear any cached redirect URLs to ensure dashboard loads first
            localStorage.removeItem('redirectUrl');
            
            // Navigate immediately - auth state is already set in the service's tap operator
            const redirectPath = response.userData.redirectTo || '/dashboard';
            this.router.navigate([redirectPath], { replaceUrl: true }).then(() => {
              // Set loading to false after navigation completes
              this.isLoading = false;
            }).catch(() => {
              // If navigation fails, still set loading to false
              this.isLoading = false;
            });
            return;
          }

          // Handle legacy response format with multipleAgency flag
          if (response.data?.userData) {
            // Apply user's saved theme and mode
            this.applyUserTheme(response.data.userData);
          }
          
          if (response.multipleAgency) {
            this.isLoading = false;
            this.showAgencySelection = true;
            const userID = response.data?.userData?._id || '';
            const userName = response.data?.userData?.name || '';
            this.userID.set(userID);
            this.userName.set(userName);
            // Save userID and userName to localStorage for header component
            if (userID) {
              localStorage.setItem('userID', userID);
            }
            if (userName) {
              localStorage.setItem('userName', userName);
            }
            if (response.data?.agencyData) {
              this.agencies.set([response.data.agencyData]);
            }
            console.log('agendcyy submii',this.showAgencySelection);
          } else {
            // If no multiple agencies, directly navigate to dashboard
            // Clear any cached redirect URLs to ensure dashboard loads first
            localStorage.removeItem('redirectUrl');
            
            // Navigate immediately - auth state is already set in the service's tap operator
            const redirectPath = response.data?.userData?.redirectTo || '/dashboard';
            this.router.navigate([redirectPath], { replaceUrl: true }).then(() => {
              // Set loading to false after navigation completes
              this.isLoading = false;
            }).catch(() => {
              // If navigation fails, still set loading to false
              this.isLoading = false;
            });
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Login error:', error);
          this.errorMessage = error.error?.message || 'Login failed. Please try again.';
          // Clear both email and password fields on error
          // this.loginForm.patchValue({ 
          //   email: '', 
          //   passcode: '' 
          // });
           // Handle specific error messages and show error-circle on appropriate field
           if (this.errorMessage) {
            if (this.errorMessage.toLowerCase().includes('password incorrect')) {
              // Show error-circle on password field
              this.isPasswordTyping = true;
              this.passcode?.markAsTouched();
              this.passcode?.setErrors({ 'backendError': true });
            } else if (this.errorMessage.toLowerCase().includes('user not found')) {
              // Show error-circle on email field
              this.isEmailTyping = true;
              this.email?.markAsTouched();
              this.email?.setErrors({ 'backendError': true });
            }
          }
        }
      });
    } else {
      // Mark all fields as touched to trigger validation messages
      Object.keys(this.loginForm.controls).forEach(key => {
        const control = this.loginForm.get(key);
        control?.markAsTouched();
      });
    }
  }

  // Handle form submission with explicit event prevention
  onFormSubmit(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.onSubmit();
    return false;
  }

  onAgencySubmit() {
    if (this.agencyForm.valid) {
      this.isLoading = true;
      const selectedAgencyId = this.agencyForm.value.agency;
      
      // Call API with selected agency ID
      this.authService.agency_login(this.userID(),selectedAgencyId ).subscribe({
        next: (response) => {
          this.showAgencySelection = false;
          
          // Clear any cached redirect URLs to ensure dashboard loads first
          localStorage.removeItem('redirectUrl');
          
          // Navigate to dashboard after successful agency selection
          // Navigate immediately - auth state is already set in the service's tap operator
          this.router.navigate(['/dashboard'], { replaceUrl: true }).then(() => {
            // Set loading to false after navigation completes
            this.isLoading = false;
          }).catch(() => {
            // If navigation fails, still set loading to false
            this.isLoading = false;
          });
        },
        error: (error) => {
          this.isLoading = false;
          this.errorMessage = error.error?.message || 'Failed to agency login. Please try again.';
        }
      });
    } else {
      // Mark all fields as touched to trigger validation messages
      Object.keys(this.agencyForm.controls).forEach(key => {
        const control = this.agencyForm.get(key);
        control?.markAsTouched();
      });
    }
  }

  // Handle agency form submission with explicit event prevention
  onAgencyFormSubmit(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.onAgencySubmit();
    return false;
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  onPasswordInput() {
    // Clear backend error when user starts typing
    if (this.errorMessage) {
      this.errorMessage = '';
    }
    // Clear backend error from password field
    if (this.passcode?.errors?.['backendError']) {
      this.passcode.setErrors(null);
    }
    this.isUserTyping = true;
    this.isPasswordTyping = true;
    this.isEmailTyping = false; // Reset email typing when password is being typed
  }

  // Clear backend error when user starts typing
  onInputFocus() {
    if (this.errorMessage) {
      this.errorMessage = '';
    }
    this.isUserTyping = true;
  }

  // Clear backend error when user starts typing in email field
  onEmailInput() {
    if (this.errorMessage) {
      this.errorMessage = '';
    }
    // Clear backend error from email field
    if (this.email?.errors?.['backendError']) {
      this.email.setErrors(null);
    }
    this.isUserTyping = true;
    this.isEmailTyping = true;
    this.isPasswordTyping = false; // Reset password typing when email is being typed
  }

  // Handle email field focus specifically
  onEmailFocus() {
    if (this.errorMessage) {
      this.errorMessage = '';
    }

     // Clear backend error from email field
     if (this.email?.errors?.['backendError']) {
      this.email.setErrors(null);
    }
    this.isUserTyping = true;
    this.isEmailTyping = true;
    this.isPasswordTyping = false; // Reset password typing when email is focused
    
    // Mark email field as touched to show validation if empty
    if (this.email) {
      this.email.markAsTouched();
    }
  }

  // Handle password field focus specifically
  onPasswordFocus() {
    if (this.errorMessage) {
      this.errorMessage = '';
    }
     // Clear backend error from password field
     if (this.passcode?.errors?.['backendError']) {
      this.passcode.setErrors(null);
    }
    this.isUserTyping = true;
    this.isPasswordTyping = true;
    this.isEmailTyping = false; // Reset email typing when password is focused
    
    // Mark password field as touched to show validation if empty
    if (this.passcode) {
      this.passcode.markAsTouched();
    }
  }

  // Convert email input to lowercase
  onEmailKeyup(event: any) {
    const input = event.target;
    const value = input.value;
    const lowercaseValue = value.toLowerCase();
    
    // Only update if the value actually changed (contains uppercase letters)
    if (value !== lowercaseValue) {
      // Update the form control value
      this.loginForm.patchValue({ email: lowercaseValue });
      
      // Set cursor position to maintain typing position
      const cursorPosition = input.selectionStart;
      setTimeout(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      }, 0);
    }
  }

  getErrorMessage(controlName: string): string {
    const control = this.loginForm.get(controlName);
    if (!control?.errors || !control.touched) return '';

    if (controlName === 'email') {
      return ValidationConstants.getEmailOrPhoneErrorMessage(control!);
    }

    if (controlName === 'passcode') {
      return ValidationConstants.getPasswordErrorMessage(control!);
    }

    return '';
  }

  // Helper getters for form validation
  get email() { return this.loginForm.get('email'); }
  get passcode() { return this.loginForm.get('passcode'); }
  get agency() { return this.agencyForm.get('agency'); }

  selectAgency(agencyId: any) {
    this.agencyForm.patchValue({ agency: agencyId });
    console.log('agennncyyy',agencyId)
    this.agency?.markAsTouched();
  }
// TrackBy function for agency list performance
trackByAgencyId(index: number, agency: any): string {
  return agency._id;
}

    /**
   * Apply user's saved theme and mode from login response ##need login response used theme
   */
  private applyUserTheme(userData: any): void {
    if (!userData) return;

    // Apply theme mode (light/dark)
    if (userData.mode === 'dark') {
      this.themeService.setTheme('dark');
    } else {
      // For any other value (including '', null, undefined), use day mode
      this.themeService.setTheme('light');
    }

    // Apply background theme if present
    if (userData.theme && userData.theme.trim()) {
      localStorage.setItem('selectedBackgroundTheme', userData.theme);
      localStorage.setItem('theme-background-active', 'true');
      document.body.classList.add('theme-background-active');
      document.body.style.backgroundImage = `url(${userData.theme})`;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // Check if click is outside the agency selection form
    const agencyForm = document.querySelector('.agency-tags');
    if (this.showAgencySelection && agencyForm && !agencyForm.contains(event.target as Node)) {
      this.agencyForm.patchValue({ agency: '' });
      this.agency?.markAsTouched();
    }
  }


  nextSlide() {
    const itemsPerPage = 2;
    const maxIndex = this.agencies().length - itemsPerPage;
    if (this.currentIndex() < maxIndex) {
      this.currentIndex.set(this.currentIndex() + 1);
    }
  }

  prevSlide() {
    if (this.currentIndex() > 0) {
      this.currentIndex.set(this.currentIndex() - 1);
    }
  }


  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}